module.exports = __webpack_public_path__ + "static/img/up-arrow.34528d9c.png";